import FileTextIcon from "@gaiaProfessionals/Icons/FileText";
import UserIcon from "@gaiaProfessionals/Icons/UserIcon";
import * as S from "@gaiaProfessionals/Widgets/HCP/Navigation/MasterNavigation.styles";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import Button from "@insite/mobius/Button";
import Icon from "@insite/mobius/Icon";
import LogOutIcon from "@insite/mobius/Icons/LogOut";
import SearchIcon from "@insite/mobius/Icons/Search";
import CartIcon from "@insite/mobius/Icons/ShoppingCart";
import UploadIcon from "@insite/mobius/Icons/Upload";
import Link from "@insite/mobius/Link";
import { useRef, useState } from "react";
import * as React from "react";

interface AccountProps {
    accountMenuWidth: string;
    accountMenuParentWidth: string;
    accountMenuRef: React.RefObject<HTMLDivElement>;
    accountMenuParentRef: React.RefObject<HTMLLIElement>;
    isAuthenticated: boolean;
    isGuest: boolean;
    isPurchaser: boolean;
    signOut: () => void;
}

// <============== Component ==============>
const NavAccount: React.FC<{ account: any }> = ({ account }) => {
    const {
        accountMenuWidth,
        accountMenuParentWidth,
        accountMenuRef,
        accountMenuParentRef,
        isAuthenticated,
        isGuest,
        isPurchaser,
        signOut,
    } = account;
    // const accountMenuParentRef = useRef<HTMLLIElement>(null);
    // const accountMenuRef = useRef<HTMLDivElement>(null);
    const onSignOutHandler = () => {
        signOut();
    };

    const [isHovered, setIsHovered] = useState(false);

    const openMenu = (): void => {
        setIsHovered(true);
    };
    const closeMenu = (): void => {
        setIsHovered(false);
    };

    // <============== Component Render ==============>
    return (
        <li
            className="iconBlock__item iconBlock__item--account"
            ref={accountMenuParentRef}
            onMouseLeave={closeMenu}
            onMouseEnter={openMenu}
            onFocus={openMenu}
            onBlur={closeMenu}
        >
            <Link
                className="iconBlock__iconWrap iconBlock__link iconButton"
                href="/MyAccount"
                aria-expanded={isHovered}
                onClick={closeMenu}
            >
                <Icon className="iconBlock__icon iconBlock__icon--account" src={UserIcon} aria-hidden="true"></Icon>
                <span className="sr-only">Manage Account</span>
            </Link>
            <S.NavDropDown
                as="div"
                className="dropdown dropdown--menu"
                ref={accountMenuRef}
                menuWidth={parseInt(accountMenuWidth, 10)}
                parentWidth={parseInt(accountMenuParentWidth, 10)}
            >
                <S.DropdownMenu>
                    <ul className="dropdownMenu__list">
                        <li className="dropdownMenu__item">
                            <Link className="dropdownMenu__link" href="/MyAccount" onClick={closeMenu}>
                                <Icon className="dropdownMenu__link-icon" src={UserIcon} aria-hidden="true"></Icon>
                                <span className="dropdownMenu__link-text">Manage Account</span>
                            </Link>
                        </li>
                        {!isPurchaser && (
                            <li className="dropdownMenu__item">
                                <Link
                                    className="dropdownMenu__link"
                                    href="/MyAccount/UploadCredentials"
                                    onClick={closeMenu}
                                >
                                    <Icon
                                        className="dropdownMenu__link-icon"
                                        src={UploadIcon}
                                        aria-hidden="true"
                                    ></Icon>
                                    <span className="dropdownMenu__link-text">Upload Credentials</span>
                                </Link>
                            </li>
                        )}
                        {isPurchaser && (
                            <li className="dropdownMenu__item">
                                <Link className="dropdownMenu__link" href="/MyAccount/Orders" onClick={closeMenu}>
                                    <Icon
                                        className="dropdownMenu__link-icon"
                                        src={FileTextIcon}
                                        aria-hidden="true"
                                    ></Icon>
                                    <span className="dropdownMenu__link-text">Order History</span>
                                </Link>
                            </li>
                        )}
                        <li className="dropdownMenu__item">
                            <Button className="dropdownMenu__link" onClick={onSignOutHandler}>
                                <Icon className="dropdownMenu__link-icon" src={LogOutIcon} aria-hidden="true"></Icon>
                                <span className="dropdownMenu__link-text">Sign Out</span>
                            </Button>
                        </li>
                    </ul>
                </S.DropdownMenu>
            </S.NavDropDown>
        </li>
    );
};

export default NavAccount;
